import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(({ variables }) => ({
  collectionContainer: {
    minHeight:'195px',
  },
  pagingContainer: {
    '& .disabled-paging': {
      opacity: '0.3'
    },
    '& .jetFontIcon': {
      paddingLeft:variables?.spacingC,
      paddingRight:variables?.spacingC
    },
    marginBottom:variables?.spacingD,
    display:'block',
    '& .pagingInnerContainer': {
      display:'flex',
      alignItems: 'center',
      justifyContent: 'end'
    }
  }
}));

export default useStyles;
